import { FullPopup } from './FullPopup'

export default FullPopup
